import React, { useState } from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { useBrandingColors, getButtonInlineStyles, getButtonHoverStyles } from '../hooks/useBrandingColors';

interface ComplaintConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ComplaintConfirmationModal: React.FC<ComplaintConfirmationModalProps> = ({ isOpen, onClose }) => {
  const colors = useBrandingColors();
  const [isPrimaryHover, setIsPrimaryHover] = useState<boolean>(false);
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full mx-4" role="dialog" aria-modal="true" aria-labelledby="confirmation-title">
        <div className="p-6 text-center">
          <div className="flex justify-center mb-4">
            <CheckCircleIcon className="h-16 w-16 text-green-500" />
          </div>
          
          <h3 id="confirmation-title" className="text-xl font-semibold text-gray-900 mb-4">
            Спасибо за обратную связь!
          </h3>
          
          <p className="text-gray-600 mb-6 leading-relaxed">
            Мы изучим ваше сообщение и дадим ответ на указанную почту в течение 1-2 рабочих дней.
          </p>
          
          <button
            onClick={onClose}
            className="w-full px-[24px] py-[14px] h-[52px] rounded-3xl transition-colors disabled:opacity-60 disabled:cursor-not-allowed font-['Inter:Medium',_sans-serif] font-medium text-[16px] text-center tracking-[-0.176px]"
            style={isPrimaryHover ? getButtonHoverStyles(colors, 'primary') : getButtonInlineStyles(colors, 'primary')}
            onMouseEnter={() => setIsPrimaryHover(true)}
            onMouseLeave={() => setIsPrimaryHover(false)}
          >
            Понятно
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComplaintConfirmationModal;
